import { IExecuteResultDto } from '../integration-test-modal.types';

export enum ResponseTab {
  BODY = 'body',
  HEADERS = 'headers'
}

export interface IResponsePanelProps {
  response?: IExecuteResultDto;
  className?: string;
}
